<template>
  <div>
    <a href="https://www.bbb.org/us/ut/lehi/profile/loans/lendio-inc-1166-22173663/#sealclick" id="bbblink" class="ruhzbum" target="_blank" rel="nofollow">
      <img
        src="https://seal-utah.bbb.org/logo/ruhzbum/bbb-22173663.png"
        onerror="this.onerror=null; this.src='/images/fallback-bbb.png'"
        style="border: 0;" alt="Lendio, Inc. BBB Business Review"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: 'BBBWidget',
  setup() {
    useHead({
      script: [
        {
          key: 'BBBSeal', // Ensure unique
          src: "//seal-utah.bbb.org/inc/legacy.js",
          type:'application/x-suppress', // Dont actually load the script
        }
      ]
    }, { mode: 'client' })
  }
}
</script>

<style lang="scss" scoped>
  /**
  * Unfortunately the script uses document.write - which can't be loaded async or deferred.
  * Instead of letting the script write this, we've copied the CSS down.
  * As of Jun 2 2026, this Script & CSS hasn't changed since 2016
  * when it was originally created - verified via web archive.
  * seal-utah.bbb.org/inc/legacy.js
  **/
  a#bbblink{display:block;position:relative;text-align:center;color:#005A78;text-decoration:none;overflow:hidden;margin:0;padding:0;}a#bbblink img{border:0;position:absolute;top:0;left:0;margin-left:0;max-width:200%;}a#bbblink.cshzbal,a#bbblink.cshzbul{width:293px;height:61px;}a#bbblink.cuvtbas,a#bbblink.cuvtbus{width:63px;height:134px;}a#bbblink.cuvtbam,a#bbblink.cuvtbum{width:69px;height:145px;}a#bbblink.cuvtbal,a#bbblink.cuvtbul{width:81px;height:171px;}a#bbblink.cuhzbas,a#bbblink.cuhzbus{width:96px;height:50px;}a#bbblink.cuhzbam,a#bbblink.cuhzbum{width:137px;height:70px;}a#bbblink.cuhzbal,a#bbblink.cuhzbul{width:160px;height:82px;}a#bbblink.ruvtbas,a#bbblink.ruvtbus{width:40px;height:75px;}a#bbblink.csvtbas,a#bbblink.csvtbus{width:153px;height:100px;}a#bbblink.csvtbam,a#bbblink.csvtbum{width:158px;height:110px;}a#bbblink.csvtbal,a#bbblink.csvtbul{width:187px;height:130px;}a#bbblink.cshzbas,a#bbblink.cshzbus{width:200px;height:42px;}a#bbblink.cshzbam,a#bbblink.cshzbum{width:250px;height:52px;}a#bbblink.ruhzbam,a#bbblink.ruhzbum{width:150px;height:69px;}a#bbblink.sevtbam,a#bbblink.rbvtbam,a#bbblink.sevtbum,a#bbblink.rbvtbum{width:60px;height:98px;}a#bbblink.sevtbam:hover img,a#bbblink.rbvtbam:hover img,a#bbblink.ruvtbam:hover img,a#bbblink.sevtbum:hover img,a#bbblink.rbvtbum:hover img,a#bbblink.ruvtbum:hover img{margin-left:-60px;}a#bbblink.ruvtbam,a#bbblink.ruvtbum{width:60px;height:110px;}a#bbblink.sehzbas,a#bbblink.rbhzbas,a#bbblink.sehzbus,a#bbblink.rbhzbus{width:100px;height:38px;}a#bbblink.sehzbas:hover img,a#bbblink.rbhzbas:hover img,a#bbblink.ruhzbas:hover img,a#bbblink.sehzbus:hover img,a#bbblink.rbhzbus:hover img,a#bbblink.ruhzbus:hover img{margin-left:-100px;}a#bbblink.ruhzbas,a#bbblink.ruhzbus{width:100px;height:48px;}a#bbblink.sevtbas,a#bbblink.rbvtbas,a#bbblink.sevtbus,a#bbblink.rbvtbus{width:40px;height:65px;}a#bbblink.sevtbas:hover img,a#bbblink.rbvtbas:hover img,a#bbblink.ruvtbas:hover img,a#bbblink.sevtbus:hover img,a#bbblink.rbvtbus:hover img,a#bbblink.ruvtbus:hover img{margin-left:-40px;}a#bbblink.sehzbal,a#bbblink.rbhzbal,a#bbblink.sehzbul,a#bbblink.rbhzbul{width:200px;height:76px;}a#bbblink.sehzbal:hover img,a#bbblink.rbhzbal:hover img,a#bbblink.ruhzbal:hover img,a#bbblink.sehzbul:hover img,a#bbblink.rbhzbul:hover img,a#bbblink.ruhzbul:hover img{margin-left:-200px;}a#bbblink.ruhzbal,a#bbblink.ruhzbul{width:200px;height:90px;}a#bbblink.sevtbal,a#bbblink.rbvtbal,a#bbblink.sevtbul,a#bbblink.rbvtbul{width:80px;height:132px;}a#bbblink.sevtbal:hover img,a#bbblink.rbvtbal:hover img,a#bbblink.ruvtbal:hover img,a#bbblink.sevtbul:hover img,a#bbblink.rbvtbul:hover img,a#bbblink.ruvtbul:hover img{margin-left:-80px;}a#bbblink.ruvtbal,a#bbblink.ruvtbul{width:80px;height:144px;}a#bbblink.sehzbam,a#bbblink.rbhzbam,a#bbblink.sehzbum,a#bbblink.rbhzbum{width:150px;height:57px;}a#bbblink.sehzbam:hover img,a#bbblink.rbhzbam:hover img,a#bbblink.ruhzbam:hover img,a#bbblink.sehzbum:hover img,a#bbblink.rbhzbum:hover img,a#bbblink.ruhzbum:hover img{margin-left:-150px;}

  $mobile-bbb-width: 100px;
  $desktop-bbb-width: 115px;

  a#bbblink.ruhzbum {
    width: $desktop-bbb-width;
    height: 55px;
    @include media-breakpoint-up(lg) {
      width: $mobile-bbb-width;
      height: 45px;
    }
  }
  a#bbblink.ruhzbum:hover img {
    margin-left: - $desktop-bbb-width;
    @include media-breakpoint-up(lg) {
      margin-left: - $mobile-bbb-width;
    }
  }
</style>
